import {
    HttpClient,
    HttpErrorResponse,
    HttpHeaders,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { BehaviorSubject, Observable, tap } from 'rxjs'
import { Location, LocationDTO } from '../../models/location.interface'
import { RequestService } from '../request/request.service'
import { Pagination } from '../../models/pagination.interface'
import { QueryGet } from '../../shared/query-types'
import { AsyncFormValidation } from '../../interceptors/error.interceptor'

@Injectable({
    providedIn: 'root',
})
export class LocationService {
    httpOptions = {
        headers: new HttpHeaders({}),
    }
    private apiUrl = environment.service_1 + 'locations/'
    private url = environment.service_1 + 'all-locations/'
    private locations = new BehaviorSubject<Location[]>([])
    locations$ = this.locations.asObservable()

    private asyncErrorValidation =
        new BehaviorSubject<AsyncFormValidation | null>(null)
    asyncErrorValidation$ = this.asyncErrorValidation.asObservable()

    private locationsSelected = new BehaviorSubject<Location | null>(null)
    $locationsSelected = this.locationsSelected.asObservable()

    constructor(
        private requestService: RequestService,
        private http: HttpClient
    ) {}

    setLocations(locations: Location[]) {
        this.locations.next(locations)
    }

    setLocation(location: Location) {
        this.locationsSelected.next(location)
    }

    allLocation(): Observable<Location[]> {
        return this.http.get<Location[]>(this.url, {
            headers: this.httpOptions.headers,
        })
    }

    allLocations(queryParams: QueryGet): Observable<Pagination<Location[]>> {
        return this.requestService.get<Location[]>(this.apiUrl, queryParams)
    }

    deleteLocation(id: number): Observable<void> {
        return this.http.delete<void>(this.apiUrl + id + '/')
    }

    updateLocation(id: number, location: LocationDTO & { id: number }) {
        return this.http.put<Location>(this.apiUrl + id + '/', location).pipe(
            tap({
                error: (err: HttpErrorResponse) => {
                    this.asyncErrorValidation.next(err.error)
                },
            })
        )
    }
}
